export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BaseSelect.vue?vue&type=template&id=4f1b1f7e&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/form/BaseSelect.vue?vue&type=template&id=4f1b1f7e&
// module id = 1728
// module chunks = 0